import { render, staticRenderFns } from "./MAP_LOCUS.vue?vue&type=template&id=fcdcd54a&scoped=true"
import script from "./MAP_LOCUS.vue?vue&type=script&lang=ts"
export * from "./MAP_LOCUS.vue?vue&type=script&lang=ts"
import style0 from "./MAP_LOCUS.vue?vue&type=style&index=0&id=fcdcd54a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdcd54a",
  null
  
)

export default component.exports